/**
 * Адреса изображений товаров.
 *
 * Файлы лежат в объектном хранилище; в базе хранится только ключ (А-706).
 * Конкретный файл собирается из ключа, размера и формата.
 */

const BUCKET = 'product-images'

// Адрес хранилища задаётся при сборке (VITE_S3_URL, см. admin/Dockerfile и
// deploy/compose.yaml): путь /images ведёт через обратный прокси в MinIO.
// Запасное значение — опубликованный порт MinIO для запуска вне Docker.
const HOST = import.meta.env.VITE_S3_URL ?? 'http://localhost:9000'

export type ImageVariant = 'thumb' | 'catalog' | 'full'

export function imageUrl(key: string, variant: ImageVariant = 'catalog'): string {
  return `${HOST}/${BUCKET}/${key}-${variant}.jpg`
}
